

<p-tree   [style]="{width:'100%'}" [value]="layerslist" (onNodeExpand)="nodeExpand($event)" (onNodeCollapse)="nodeCollapse($event)" >
 	<ng-template let-node pTemplate="default">
 		
 			<div class="tree-rowwrap">
	        	
	        		
	        	<div class="tree-line" (click)="nodeClick(node,true,null)">

				<div *ngIf="node.data?.type !== undefined" class="tree-iconcell">
					<p-toggleButton
					styleClass="mapLayerToggleButton iconBtn"
					[pt]="{ button: { class: 'layers-iconbtn' } }"
					(onChange)="nodeSelect($event,node,true)"
					onLabel="" offLabel=""
					onIcon="pi pi-check-circle" offIcon="pi pi-circle"
					[(ngModel)]="node.selected">
					</p-toggleButton>
				</div>

				<div class="tree-labelcell">
					<div *ngIf="node.children"
						[ngClass]="{'nodeLabel':true,'rootFont':node.parent === undefined,'childTreeNodeLabel':node.parent !== undefined}"
						pTooltip="{{node.fulllabel}}">
					{{ node.label.toUpperCase()}}
					</div>

					<div *ngIf="!node.children"
						class="nodeLabel childTreeNodeLabel"
						pTooltip="{{node.fulllabel}}">
					{{ node.label}}
					</div>
				</div>

				<div class="tree-iconcell"
					*ngIf="(((node.data.type === 'wfs' || node.data.type === 'wms') && node.data.showtable) || node.data.additionalData); else blank_content1">
					<p-toggleButton
					[disabled]="!node.selected"
					styleClass="mapLayerToggleButton attTableToggleButton iconBtn"
					[pt]="{ button: { class: 'layers-iconbtn' } }"
					(onChange)="tableOn($event,node)"
					onLabel="" offLabel=""
					onIcon="pi pi-table" offIcon="pi pi-table"
					[(ngModel)]="node.data.tableOn">
					</p-toggleButton>
				</div>
				<ng-template #blank_content1><div class="tree-iconcell"></div></ng-template>

				<div class="tree-iconcell" *ngIf="node.data?.info !== undefined; else blank_content2">
					<p-toggleButton
					[disabled]="!node.selected"
					styleClass="mapLayerToggleButton featInfoToggleButton iconBtn"
					[pt]="{ button: { class: 'layers-iconbtn' } }"
					onLabel="" offLabel=""
					onIcon="pi pi-info-circle" offIcon="pi pi-info-circle"
					[(ngModel)]="node.data.info"
					(onChange)="showInfo($event, node)">
					</p-toggleButton>
				</div>
				<ng-template #blank_content2><div class="tree-iconcell"></div></ng-template>

				</div>
   				
   				
	        	
				
				<div *ngIf="node.selected" class="tree-controls">
  					<div class="legendPanel tree-fixed">
			        	
		<!-- 	        		<div *ngIf="(node.data.info !== undefined)"  > -->
		<!-- 						<p-checkbox [style]="{'display':'none'}" name="info" label="Info" value="node.data.info"  [(ngModel)]="node.data.info" binary="true" (onChange)="showInfo(checked,node)"></p-checkbox> -->
		<!--     					<br> -->
		<!--     				</div> -->
		    			
		    				<div *ngIf="(node.cqlDropBoxes !== undefined && node.cqlDropBoxes.length > 0 && node.data.showCqlDropdown !== undefined && node.data.showCqlDropdown === true)">
		    				
		    					<p-select
									styleClass="tree-dropdown"
									[panelStyleClass]="'layers-tree-dd-panel tree-dropdown-panel ' + node.styleClassBg"
									[options]="node.naseljaCqlDropBoxVals"
									(onChange)="doCqlFilter($event,0)"
									[(ngModel)]="node.naseljaSelected">
								</p-select>

								<div *ngFor="let cqlDropBoxVals of node.cqlDropBoxes; index as i;">
								<p-select
									styleClass="tree-dropdown"
									[panelStyleClass]="'layers-tree-dd-panel tree-dropdown-panel ' + node.styleClassBg"
									[options]="cqlDropBoxVals"
									(onChange)="doCqlFilter($event,i)"
									[(ngModel)]="node.cqlSelected[i]">
								</p-select>
								</div>
		    				</div>
		
		    				<!--  img *ngIf="(node.data.showlegend === undefined || node.data.showlegend)" src="{{node.data.legend}}"/ -->
		    				
							<p-slider  *ngIf="(node.data.showslider === undefined || node.data.showslider)"  class = "layerOpacitySlider"  onSlideEnd="setLayerTransparency($event)"  (ngModelChange)="transparencyChanged($event,node)" [(ngModel)]="node.data.layertransparency" [min]="0" [max]="100" >
							
							
							</p-slider>
		    				  
					</div>
				</div>
        	</div>
        
    </ng-template>
  
</p-tree>

